import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const headers = {
  "x-access-token": localStorage.getItem("Token"),
};

/* USER AUTHENTICATION */

// User SignUp
export async function userSignUp(data) {
  return axios.post(`${API_URL}/ecomm/api/v1/auth/signup`, data);
}
// User SignIN
export async function userSignIn(data) {
  return axios.post(`${API_URL}/ecomm/api/v1/auth/login`, data);
}
// Send resetlink to email
export async function sendResetLink(data) {
  return axios.post(`${API_URL}/ecomm/api/v1/sendPassword`, data);
}
// Confirm to RESET the Passowrd
export async function confirmResetToken(data) {
  return axios.post(`${API_URL}/ecomm/api/v1/resetPassword`, data);
}

/* PRODUCTS */

// API to get products from mock server
export const getProducts = function () {
  return axios
    .get(`${API_URL}/ecomm/api/v1/products/`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    });
};

// GET Product by id
export const getProductsById = function (id) {
  return axios
    .get(`${API_URL}/ecomm/api/v1/products/${id}`)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    });
};

export async function getCategory() {
  return axios.get(`${API_URL}/ecomm/api/v1/category`);
}

/* ADDRESS */
export async function getAddress() {
  try {
    const response = await axios.get(`${API_URL}/ecomm/api/v1/address`, {
      headers,
    });
    return response.data;
  } catch (error) {
    // Handle error
    console.error(error);
  }
}
export async function createAddress(data) {
  return axios.post(`${API_URL}/ecomm/api/v1/address`, data, { headers });
}

export async function updateAddress(data, addressId) {
  return axios.put(`${API_URL}/ecomm/api/v1/address/${addressId}`, data, {
    headers,
  });
}

/* ORDERS */
// API to get products from mock server
export const getOrders = function () {
  return axios
    .get(`${API_URL}/ecomm/api/v1/orders`, {
      headers,
    })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    });
};

export async function createOrder(data) {
  try {
    const response = await axios.post(`${API_URL}/ecomm/api/v1/order`, data, {
      headers,
    });
    return response.data;
  } catch (error) {
    // Handle error
    console.error(error);
  }
}

export async function getOrderById(orderid) {
  try {
    const response = await axios.get(
      `${API_URL}/ecomm/api/v1/order/${orderid}`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    // Handle error
    console.error(error);
  }
}
